module.exports = __webpack_public_path__ + "img/footer8.b6596e49.svg";